import { Component, OnInit,  Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, AbstractControl,FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-dynamic-son-list',
  templateUrl: './dynamic-son-list.component.html',
  styleUrls: ['./dynamic-son-list.component.scss']
})
export class DynamicSonListComponent implements OnInit {
  //mySonFormGroup: FormGroup = new FormGroup({});
  //message = 'Hola Mundo!';
  @Input() parentForm: FormGroup;
  @Input() mySonListName:string;
  @Input() mylabel:string;
  @Input() itemList:string[];
  fieldCounter = 0;
  fieldList:string[];
  
  constructor() { 
 
  }
  
  ngOnInit() {
    
  }

  // ngAfterContentInit()
  // {
  //   if(this.itemList && this.itemList.length>0)
  //   {
  //     this.itemList.map(item=>{
  //       this.addItem(item);
  //     })
  //   }
  //   else {
  //     this.addItem();
  //   }
  // }
  
 get addFlexListElement() {
    return this.parentForm.get(this.mySonListName) as FormArray
  }
  
  addItem(value?:string) {
    if(value){
      this.addFlexListElement.push(new FormControl(value));
    }
    else{
      this.addFlexListElement.push(new FormControl(''));
   }
  }

}
